__turbopack_context__.v({
  "dark_bg": "Default-module__HUpOxa__dark_bg",
  "light_bg": "Default-module__HUpOxa__light_bg",
  "logo": "Default-module__HUpOxa__logo",
});
